<template>
  <div>
    <fields
      :fields="fields.all()"
      :model="item"
      layout="vertical" />
  </div>
</template>

<script>

import { FormMixin } from 'stylemix-base';

const fields = [{
  "attribute": 'image',
  "label": "Image",
  "component": 'image-field',
}, {
  "attribute": 'title',
  "label": 'Title',
  "component": 'text-field',
}, {
  "attribute": "description",
  "label": 'Description',
  "component": 'textarea-field',
}];

export default {

  mixins: [FormMixin],

  props: {
    item: Object
  },

  created() {
    this.setFields(fields);
  }

}
</script>
